import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function getTimeLeft(startDate: string | undefined, endDate: string | undefined) {
  if (!startDate || !endDate) {
    return { timeLeft: "N/A", percentLeft: 0 };
  }

  const start = new Date(startDate).getTime();
  const end = new Date(endDate).getTime();
  const now = new Date().getTime();

  if (now >= end) {
    return { timeLeft: "Expired", percentLeft: 0 };
  }

  const totalDuration = end - start;
  const elapsed = now - start;
  const remaining = end - now;

  const percentLeft = Math.max(0, Math.min(100, Math.round((elapsed / totalDuration) * 100)));

  const days = Math.floor(remaining / (1000 * 60 * 60 * 24));
  const months = Math.floor(days / 30);

  let timeLeft = "";
  if (months > 0) {
    timeLeft = `${months} month${months > 1 ? "s" : ""} left`;
  } else if (days > 0) {
    timeLeft = `${days} day${days > 1 ? "s" : ""} left`;
  } else {
    const hours = Math.floor(remaining / (1000 * 60 * 60));
    timeLeft = `${hours} hour${hours > 1 ? "s" : ""} left`;
  }

  return { timeLeft, percentLeft };
}
